import styled from '@emotion/styled';
import { Select } from 'src/web/components/Select/component';
import { MARKETING_PAGE_BREAKPOINT_TABLET } from 'src/web/components/Style/breakpoints';
import { TextField } from 'src/web/components/TextField/component';

const mediaQuery = `@media (max-width: ${MARKETING_PAGE_BREAKPOINT_TABLET})`;

export const ModalContentWrapper = styled('div')({
  '.modal-dialog': {
    maxWidth: 500,
  },
});

export const StyledTextField = styled(TextField)({
  width: '100%',
});

export const StyledSelect = styled(Select)({
  width: '100%',
});

export const InputBox = styled('div')(
  ({ maxWidth = 'auto' }: { maxWidth?: number | string }) => ({
    flex: 1,
    maxWidth,
    label: {
      fontSize: 14,
      fontWeight: 600,
    },
    marginBottom: 16,
  })
);

export const SubHeader = styled('div')({
  fontSize: 16,
});

export const AddressContent = styled('div')({
  marginTop: 16,
});

export const AddressRow = styled('div')({
  display: 'flex',
  '& > *': {
    marginRight: 20,
    [mediaQuery]: {
      marginRight: 0,
    },
  },
  '& > *:last-child': {
    marginRight: 0,
  },
  [mediaQuery]: {
    flexDirection: 'column',
  },
});
